<div *ngIf="pvModules.length > 0">
  <h3>PV-Module</h3>
  <div *ngIf="!showOnlyTotal">
    <section *ngFor="let pvModule of pvModules; first as isFirst; last as isLast">
      <h4>
        <span *ngIf="pvModule.count">{{ pvModule.count.toString() }} x</span>
        {{ pvModule.manufacturer }}
        <span *ngIf="pvModule.manufacturer && pvModule.type">-</span>
        {{ pvModule.type }}
      </h4>
      <div>
        <app-value-with-label
          *ngIf="pvModule.modulePowerWatt"
          [label]="'Einzelleistung der Module (Wp):'"
          [value]="(pvModule.modulePowerWatt | number : undefined : 'de-DE') + ' Wp'"></app-value-with-label>
      </div>
      <div>
        <app-value-with-label
          *ngIf="pvModule.modulePowerWatt > 0"
          [label]="'Gesamtleistung der PV-Module:'"
          [value]="
            ((pvModule.count * pvModule.modulePowerWatt) / 1000 | number : undefined : 'de-DE') + ' kWp'
          "></app-value-with-label>
      </div>
    </section>
  </div>
  <section>
    <app-value-with-label
      [label]="'<b>Gesamte Leistung der PV-Module:</b>'"
      [value]="
        '<b>' +
        (pvModules.length | totalPowerPvModulePipe : pvModules | number : undefined : 'de-DE') +
        ' kWp</b>'
      "></app-value-with-label>
  </section>
</div>
